import accountTypeOverview from "../text/account_type_overview";

export const addToSummaryArr=(accountType, subType, totalInitialValue, totalCurrentValue, summaryArr) => {
    let accountLabel = accountType;
   
    //  sortNbr of 9999 is assigned to total records
    let sortNbr = 9999;
    const accountOverviewInfo = accountTypeOverview.find(elem => elem.accountType === accountType);
    if (accountOverviewInfo){
        accountLabel = accountOverviewInfo.label;
        sortNbr = accountOverviewInfo.sortNbr;
    }
    if (accountType === "401KMatch"){
        accountLabel = "401(k) Company Match";
        accountType = "retirement";
        const accountOverviewInfo = accountTypeOverview.find(elem => elem.accountType === accountType);
        totalInitialValue = 0;
        sortNbr = accountOverviewInfo.sortNbr + 10;
    }
    const indx = summaryArr.findIndex(elem => elem.accountLabel + elem.subType === accountLabel + subType);
    if (indx === -1){
        let totalGainLoss = (+totalCurrentValue - +totalInitialValue).toFixed(2);
        const investTypeObj = {accountLabel: accountLabel,  accountType: accountType, subType: subType, 
            totalInitialValue: +totalInitialValue, totalCurrentValue: +totalCurrentValue, 
            totalGainLoss: totalGainLoss, sortNbr: sortNbr}
        summaryArr.push(investTypeObj);
    }else{
        summaryArr[indx].totalInitialValue += +totalInitialValue;
        summaryArr[indx].totalCurrentValue += +totalCurrentValue;
        summaryArr[indx].totalGainLoss = ((+summaryArr[indx].totalCurrentValue).toFixed(2) -
            (+summaryArr[indx].totalInitialValue).toFixed(2));
    }
}
export default addToSummaryArr